import { render, staticRenderFns } from "./newTable.vue?vue&type=template&id=6f20675e"
import script from "./newTable.vue?vue&type=script&lang=js"
export * from "./newTable.vue?vue&type=script&lang=js"
import style0 from "./newTable.vue?vue&type=style&index=0&id=6f20675e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports